import axios, { AxiosRequestConfig } from 'axios'

import { logger } from '../lib/logger'

type SuccessResponse<T> = {
  status: 'success'
  data: T
}

type ErrorResponse = {
  status: 'error'
  message: string
  debug: {
    body: {
      errors: { status: number; title: string }[]
    }
  }
}

export type OneplatformResponse<ResponseData> = SuccessResponse<ResponseData> | ErrorResponse

const apiRequest = <Response>(config: AxiosRequestConfig) =>
  axios
    .request<OneplatformResponse<Response>>(config)
    .then((r) => r.data)
    .then((r) => {
      if (r.status !== 'success') throw new Error(`Request to ${config.url} failed: ${r.message}`)
      return r.data
    })
    .catch((error) => {
      logger.error(error)
      throw error
    })

export const get = <Response>(url: string, data?: any, config?: AxiosRequestConfig): Promise<Response> => {
  return apiRequest<Response>({ ...config, method: 'get', url, data })
}

export const post = <Response>(url: string, data?: any, config?: AxiosRequestConfig): Promise<Response> => {
  return apiRequest<Response>({ ...config, method: 'post', url, data })
}
